import { render, staticRenderFns } from "./UploadControl.vue?vue&type=template&id=3c9ac56d"
import script from "./UploadControl.vue?vue&type=script&lang=ts"
export * from "./UploadControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports